import resetState from '@/helpers/resetState';
import store from '@/store';
import { ABI } from './ABI';
import { Contract } from 'web3-eth-contract';

async function contract(): Promise<Contract> {
  const address = store.getters.getMasterAddress;
  return new Promise(resolve => {
    let contract = new window.web3.eth.Contract(ABI, address);
    resolve(contract);
  });
}

const initialState = {
  network: null,
  isConnected: false,
  blockNumber: null,
  wallet: null,
  loading: false
};

const state = {
  network: initialState.network,
  isConnected: initialState.isConnected,
  blockNumber: initialState.blockNumber,
  wallet: initialState.wallet,
  loading: initialState.loading,
  networks: {
    '1': 'Main Net',
    '2': 'Deprecated Morden test network',
    '3': 'Ropsten test network',
    '4': 'Rinkeby test network',
    '42': 'Kovan test network',
    '4447': 'Truffle Develop Network',
    '5777': 'Ganache Blockchain',
    '100': 'xDai Main'
  }
};

const getters = {
  getNetwork: state => state.network,
  getConnectedStatus: (state, getters) => {
    if (state.isConnected && state.blockNumber && getters.getOwnerCounter > 0) return true;
    return false;
  },
  getBlockNumber: state => state.blockNumber,
  getWallet: state => state.wallet
};

const mutations = {
  setNetwork: (state, item) => {
    state.network = item;
  },
  setConnectedStatus: (state, item) => {
    state.isConnected = item;
  },
  setBlockNumber: (state, item) => {
    state.blockNumber = item;
  },
  setWallet: (state, item) => {
    state.wallet = item;
  },
  resetMasterFeature: state => {
    resetState(state, initialState);
  }
};

const actions = {
  initMasterFeature({ dispatch }) {}
};

export default {
  state,
  getters,
  actions,
  mutations
};
